<template>
  <v-container>
    <v-card class="pa-4" elevation="10" shaped outlined>
      <v-simple-table class="text-right" dense>
        <thead></thead>
        <tbody>
        <tr>
          <td>درگاه پرداخت</td>
          <td>
            {{ userPayment.GW.Name }}
          </td>
        </tr>

          <tr>
            <td>بابت</td>
            <td>{{ userPayment.Group }}</td>
          </tr>
        <tr v-if="userGroupLoad.Memo_Enable">
          <td class="left">{{ userGroupLoad.Memo_Title }}</td>
          <td class="right">{{ userPayment.Memo }} </td>
        </tr>
          <tr>
            <td>مبلغ</td>
            <td>{{ Number(userPayment.amount).toLocaleString() }} ریال </td>
          </tr>



          <tr v-if="userGroupLoad.NC_Enable">
            <td>کد ملی</td>
            <td>{{ userPayment.NC }}</td>
          </tr>

          <tr v-if="userGroupLoad.Name_Enable">
            <td>نام</td>
            <td>{{ userPayment.Name }} </td>
          </tr>
          
          <tr v-if="userGroupLoad.Family_Enable">
            <td>
              نام خانوادگی
            </td>
            <td>{{ userPayment.Family }}</td>
          </tr>
<!--          <tr>-->
<!--            <td>شناسه پرداخت</td>-->
<!--            <td>{{ orderID }}</td>-->
<!--          </tr>-->

          <tr v-if="userGroupLoad.Mobile_Enable">
            <td>همراه</td>
            <td>{{ userPayment.Mobile }}</td>
          </tr>

          <tr v-if="userGroupLoad.EMail_Enable">
            <td>ایمیل</td>
            <td>{{ userPayment.Email }}</td>
          </tr>
        <tr v-if="userGroupLoad.Tel_Enable">
          <td>تلفن</td>
          <td>{{ userPayment.Tel}}</td>
          <!-- {{ userPayment }} -->
          <!-- {{ userGroupLoad }} -->
        </tr>
        </tbody>
      </v-simple-table>
      <v-row>
        <v-col>
          <v-btn class="error ma-4" v-on:click="cancleBtn" small>انصراف</v-btn>
          <v-btn :loading="loadReportIsLoading==='submit_page_btn_is_loading'" class="success ma-4" small @click="payment"
            >تایید اطلاعات و پرداخت</v-btn
          >
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Submit",
  data: () => ({
    OrderID:"",
    GWID:"",
  }),
  computed: mapState({
    userPayment: (state) => state.currentUserPayment,
    userGroupLoad:(state)=> state.userGroupLoad_two,
    
    // orderID: (state) => state.orderID,
    // userGWDDL: (state) => state.userGWDDL,
    // userGroupDDL: (state) => state.userGroupDDL,
    // loadReportIsLoading: (state) => state.loadReportIsLoading,

  }),
  created() {
    window.console.log("Submit Component Is Created!");
    window.console.log("******** userPayment is: *******");
    window.console.log(this.userPayment);
    window.console.log(this.userGroupDDL);
    this.GWID=this.$route.params.Gateway;
    this.OrderID=this.$route.params.OrderID;
      this.$store.commit("pushQueue", {
        functionName: "User_Submit_Load",
        data: {
          GWID: this.GWID,
          OrderID: this.OrderID,
        }
      });


  },
  methods: {
    payment() {
      // this.$store.commit('setLoadReportIsLoading',{newStatus : "submit_page_btn_is_loading"}); //TODO:: Look at ME!
      this.$store.commit("pushQueue", {
        functionName: "User_GoIPG",
        data: {
          GWID: this.GWID,
          TerminalID: this.userPayment.TerminalID,
          OrderID: this.OrderID,
          NC: this.userPayment.NC
        }
      });
    },
    cancleBtn(){
      if(this.userGroupLoad.EnableWebService && this.userPayment.CallBackURL.indexOf('http') == 0){
        window.location.href = this.userPayment.CallBackURL + "&id2=" + this.userPayment.ID2  + "&result=-1";
      }
      else{
        this.$router.push('/form')
      }

    }
  //   find() {
  //     let index = this.userGroupDDL.findIndex(element => element.ID == this.userPayment.TerminalID);
  //     if(index !== -1) {
  //       return this.userGroupDDL[index].Name;
  //     }
  //   },
  //   find2() {
  //   let index = this.userGWDDL.findIndex(element => element.ID == this.userPayment.GWID);
  //     if(index !== -1) {
  //     return this.userGWDDL[index].Title;
  //   }
  // }
  }
};
</script>

<style scoped>
</style>